import { render, staticRenderFns } from "./MeilleurMenuQuotidien.vue?vue&type=template&id=ebf5cd46&scoped=true"
var script = {}
import style0 from "./MeilleurMenuQuotidien.vue?vue&type=style&index=0&id=ebf5cd46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebf5cd46",
  null
  
)

export default component.exports